import { PointExpression } from 'leaflet';
import { Season } from 'src/app/core/domain/season.enum';
import { WritablePart } from 'src/app/core/utils/type-helper';
import { AssetStatus } from 'src/app/maps/domain/livedata/status.enum';
import { MapElement } from 'src/app/maps/domain/masterdata/map-element.model';
import { MapPosition } from 'src/app/maps/domain/masterdata/map-position.model';
import { OperatingHours } from 'src/app/maps/domain/masterdata/operating-hours.model';
import { SisMapAssetCategory } from 'src/app/maps/domain/masterdata/sismap-asset-category.enum';
import { AssetSubStatus } from '../livedata/substatus.enum';

export class Gastro implements MapElement {
  static readonly defaultColor: string = 'white';
  static readonly defaultIconSize: PointExpression = [18, 18];

  static readonly empty: Gastro = new Gastro({ guid: null, status: AssetStatus.Disabled });

  readonly category = SisMapAssetCategory.Gastro;

  guid: string;
  name: string;
  nameEn?: string;
  season: Season;
  status: AssetStatus;
  type: string;
  contact?: string;
  location?: string;
  phone?: string;
  email?: string;
  website?: string;
  websiteEn?: string;
  info?: string;
  iconPositions: MapPosition[];
  iconWidth: number;
  iconHeight: number;
  iconImageName?: string;
  operatingHoursEnabled: boolean;
  operatingHours: OperatingHours[];

  label?: string;
  subStatus?: AssetSubStatus;
  disallowPopUp: boolean;
  disallowHighlight: boolean;
  isCategorySki: boolean;
  isGrey: boolean;
  path?: string;
  pathDashArray?: string;
  pathWeight?: number;
  pathColor?: string;
  pathBackgroundColor?: string;
  defaultPathWeight: number;
  defaultPathColor: string;
  iconAlwaysOnTop?: boolean;
  iconDisableBaseZoom?: boolean;
  iconSvgBlobName?: string;
  iconHtml?: string;
  iconUseStatus?: boolean;
  iconUseMeteoData?: boolean;
  newlyAdded?: boolean;

  constructor(init?: Partial<WritablePart<Gastro>>) {
    Object.assign(this, init);
  }
}
